import { Injectable } from '@angular/core';
import { Usuario } from '../models/usuario.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private readonly SESSION_KEY = 'usuario';

  get InfoUsuario(): Usuario {
    const usuarioData = sessionStorage.getItem(this.SESSION_KEY);
    return usuarioData ? (JSON.parse(usuarioData) as Usuario) : null;
  }

  set InfoUsuario(usuario: Usuario) {
    if (usuario) {
      sessionStorage.setItem(this.SESSION_KEY, JSON.stringify(usuario));
    } else {
      sessionStorage.removeItem(this.SESSION_KEY);
    }
  }

  clearUsuario(): void {
    sessionStorage.removeItem(this.SESSION_KEY);
    sessionStorage.removeItem('urlSeusCerrar');
  }
}